import React from 'react';
import { StarIcon, MoonIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Hero() {
  return <section className="w-full bg-cream" aria-labelledby="hero-title" data-id="element-31" data-mp="ej4o9zmlcfgi">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 px-5 py-12 lg:grid-cols-2 lg:gap-14 lg:py-20" data-id="element-32" data-mp="9k0eb6ruedp4">
        <div className="order-2 lg:order-1" data-id="element-33" data-mp="4n1jem0cu2pv">
          <span className="inline-flex items-center gap-2 rounded-full border border-slateblue-200 bg-white px-3 py-1.5 text-xs font-semibold uppercase tracking-widest text-slateblue-600" data-id="element-34" data-mp="129h21r4ip6f0">
            <MoonIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-35" data-mp="x8jo5qqjiyjb" />
            Guía digital · Acceso inmediato
          </span>

          <h1 id="hero-title" className="mt-5 font-display text-4xl font-black leading-[1.05] text-slateblue-900 sm:text-5xl lg:text-[3.4rem]" data-id="element-36" data-mp="ncq0pcba9kmr">
            ¿Tu bebé no duerme?
            <span className="block text-coral" data-id="element-37" data-mp="3825xcnx6o3kb">
              Aplica el Reseteo de 72 Horas
            </span>
            y recupera tus noches.
          </h1>

          <p className="mt-5 max-w-xl text-lg leading-relaxed text-slateblue-600" data-id="element-38" data-mp="3j6o8rb5sq6lv">
            El protocolo paso a paso que ayuda a tu bebé a dormir de corrido sin
            métodos extremos, sin culpa y sin dejarlo llorar solo. Empieza esta
            misma noche.
          </p>

          <div className="mt-7 flex flex-wrap items-center gap-3" data-id="element-39" data-mp="3ebisarv5xk56">
            <div className="flex items-baseline gap-3 rounded-xl border-2 border-dashed border-coral/50 bg-white px-4 py-3" data-id="element-40" data-mp="30h9cdu1225nt">
              <span className="text-sm font-semibold text-slateblue-400 line-through" data-id="element-41" data-mp="35a2jupnwrs3l">
                $27
              </span>
              <span className="font-display text-3xl font-black text-coral" data-id="element-42" data-mp="2viy4vpy8g78r">
                $6.39
              </span>
            </div>
            <p className="text-sm font-medium text-slateblue-600" data-id="element-43" data-mp="2hk85g3nxxvh8">
              Menos de lo que cuesta
              <br className="hidden sm:block" data-id="element-44" data-mp="2ljgyf6b5ppbq" /> un café con leche.
            </p>
          </div>

          <div className="mt-7 max-w-md" data-id="element-45" data-mp="s2tenov66frb">
            <CtaButton data-id="element-46" data-mp="s3us1zznrec7" />
          </div>

          <div className="mt-6 flex items-center gap-3" data-id="element-47" data-mp="nb1imyt8vhts">
            <div className="flex" aria-hidden="true" data-id="element-48" data-mp="n9i3jbjbrctl">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-49" data-mp="i9vu7d6magq2" />)}
            </div>
            <p className="text-sm font-semibold text-slateblue-600" data-id="element-50" data-mp="1b04cr652f356">
              Más de 1,200 padres ya recuperaron su descanso
            </p>
          </div>
        </div>

        <div className="order-1 lg:order-2" data-id="element-51" data-mp="111omt6hrxzx9">
          <div className="relative" data-id="element-52" data-mp="114kieo65gcij">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/6ef7bf79-03d0-4887-8787-8bebf4e63cc6.jpg" alt="Bebé durmiendo plácidamente en una cuna moderna con luz suave de la mañana" className="aspect-[4/5] w-full rounded-3xl object-cover shadow-xl" data-id="element-53" data-mp="x1w96fdix3l1" />
            <div className="absolute -bottom-5 left-4 rounded-2xl bg-slateblue-900 px-5 py-3 text-white shadow-lg sm:left-6" data-id="element-54" data-mp="1xam4cnf59kxc">
              <p className="text-[11px] font-semibold uppercase tracking-widest text-slateblue-200" data-id="element-55" data-mp="218tpdugn58ec">
                Resultados desde
              </p>
              <p className="font-display text-2xl font-black leading-tight" data-id="element-56" data-mp="2b0zhr5at1ru2">
                la noche 1
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}